import styled from '@emotion/styled';
import GridCard from '@components/Registration/Views/CardView/GridCard';
import {Devices} from '@styles/tokens';
import {col, mq} from '@styles/helpers';
import {MockGridCard} from '@components/Registration/Views/CardView/GridCard/GridCard';
import useMeasureCols from '@hooks/useMeasureCols';
import {useTransition} from 'react-spring';

const mockEntries = Array(15).fill('');

export const GridView = ({ onStudentSelected, students }) => {
  const cols = useMeasureCols(137, 20);

  const transitions = useTransition(
    students.data?.map((data) => ({
      ...data,
    })),
    {
      opacity: 1,
      key: (item) => item?.sis_id,
      from: { opacity: 0 },
      leave: { opacity: 0 },
    },
  );

  return (
    <ViewContainer rows={cols}>
      {students.data?.length > 0
        ? transitions((style, item, _, index) => (
            <GridCard style={style} onClick={() => onStudentSelected(item?.sis_id, item.type === 3?item?.duration:null)} content={item} key={index} index={index} />
          ))
        : mockEntries.map((_, i) => <MockGridCard key={i} />)}
    </ViewContainer>
  );
};

const ViewContainer = styled.div<{ rows: number }>`
  position: relative;
  display: grid;
  grid-template-columns: repeat(${({ rows }) => rows}, 1fr);
  grid-template-auto: rows;
  grid-template-rows: 174px;
  grid-gap: 14px 20px;
  justify-content: center;
  width: var(--site-width);
  margin: 0 var(--padding);
  height: 100%;
  padding-top: 20px;
  padding-bottom: calc(var(--footer-height) + 20px);

  /* ${mq(Devices.tablet)} {
    grid-template-columns: 1fr 1fr; */
  /* } */

  > div:nth-of-type(n) {
    /* width: ${col(1.3, 12)}; */
    cursor: pointer;
  }
`;

export default GridView;
